import React, { useEffect, useRef, useState } from 'react';
import { FlatList, Image, View } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../../globalComponents/NativeOverrides';
import { market_getSuggestedMarkets } from '../../../../store/actionsv1/markets';
import { PublicPlayerProps } from '../../../../store/types/auth_svc';
import { EventOrderStatProps, MarketProps, TradeProps } from '../../../../store/types/mk_svc';
import TeamMarketCard from './TeamMarketCard';
import moment from 'moment';
import { useIsInViewport } from '../../../../utilsv1/helpers';
import ExoticMarketCard from './ExoticMarketCard';
import AthleteMarketHolder from '../../../../Componentsv1/AthleteMarketHolder';
import { event_bulkGetAthletes } from '../../../../store/actionsv1/events';
import EventMarketHolder from '../../../../Componentsv1/EventMarketHolder';
import AthleteTourneyMarketHolder from '../../../../Componentsv1/AthleteTourneyMarketHolder';
import { Components } from 'be-components';
import MatchMarketHolder from '../../../../Componentsv1/MatchMarketHolder';
import { MatchProps } from '../../../../store/types/sr_svc';


type SuggestedMarketsProps = {
    navigation:any,
}

const SuggestedMarkets = ({navigation}:SuggestedMarketsProps) => {
    const [ minimized, setMinimized ] = useState(false);
    const [ last_pulled, setLastPulled ] = useState<any>(undefined)

    const dispatch = useDispatch();
    const player:PublicPlayerProps |undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const matches:{ [key:string]: MatchProps } = useSelector((state:any) => state.event.matches, (left, right) => left.length == right.length);
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets.filter(m => m.suggested))
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width);
    const suggested_markets_list: {updated:number, suggested_markets: EventOrderStatProps[] } = useSelector((state:any) => state.market.suggested_markets_list, (left, right) => left.updated == right.updated)
    let { suggested_markets } = suggested_markets_list;

    let new_suggested_markets:EventOrderStatProps[] = []
    suggested_markets.map(sm => {
        if(sm.event_type == 'match'){
            let existing = new_suggested_markets.find(newsm => newsm.event_type == 'match' && newsm.event_id == sm.event_id);
            if(existing){ return }
        }
        new_suggested_markets.push(sm)
    })

    let athlete_ids = new_suggested_markets.filter(sm => sm.side_type == 'athlete').map(sm => sm.side_id ?? '0');
    let team_ids = new_suggested_markets.filter(sm => sm.side_type == 'team').map(sm => sm.side_id ?? '0')


    new_suggested_markets.map(sm => {
        if(sm.event_type != 'match'){ return }
        let match = matches[sm.event_id]
        if(!match){ return }
        if(match.participant_type == 'athlete'){ athlete_ids = athlete_ids.concat(match.participants) }
        if(match.participant_type == 'team'){ team_ids = team_ids.concat(match.participants) }
    })

    //Update when enters viewport
    const ref = useRef()
    const isInViewport1 = useIsInViewport(ref)


    useEffect(() => {
        if(athlete_ids.length == 0){ return }
        dispatch(event_bulkGetAthletes(athlete_ids));
    },[athlete_ids.length])

    
    useEffect(() => {
        if(markets.length == 0){ return }
        if(!player){ return }
        if(!isInViewport1){ return }
        if(!last_pulled){
            //If there is no last pulled - then get data
            getSuggestedMarketsFromServer()
            return
        }
        if(moment().diff(last_pulled, 'seconds') > 10){
            getSuggestedMarketsFromServer();
            return
        }
        
    },[isInViewport1, markets.length, player?.player_id])

    const getSuggestedMarketsFromServer = async() => {
        setLastPulled(moment())
        await dispatch(market_getSuggestedMarkets(markets.map(m => m.market_id), 0))
    }

    const renderSuggestedMarkets = (data: { item: EventOrderStatProps, index:number }) => {
        return (
            <View style={{ flexDirection: 'row' }}>
                {renderMarket(data.item)}
            </View>
        )
        
    }

    const renderMarket = (item:EventOrderStatProps) => {
        const market = markets.find(m => m.market_id == item.market_id)

        if(!market){ return <></> }
        switch(market.level){
            case 'event':
                if(market.event_type == 'team'){
                    return <EventMarketHolder navigation={navigation} event_id={item.event_id} market_id={item.market_id} />
                }
                if(market.event_type == 'match'){
                    return <MatchMarketHolder navigation={navigation} hide_liquidity={true} match_id={item.event_id} market_id={item.market_id} />
                }
                return <></>
            case 'athlete':
                if(market.event_type == 'team'){
                    return <AthleteMarketHolder navigation={navigation} event_id={item.event_id} market_id={item.market_id} athlete_id={item.side_id} />
                }
                if(market.event_type == 'tournament'){
                    return <AthleteTourneyMarketHolder navigation={navigation} tournament_id={item.event_id} market_id={item.market_id} athlete_id={item.side_id}/>
                }
                return <></>
            default: return <></>
        }
    }


    if(!player){ return <></> }


    return (
        <View ref={ref}>
            { suggested_markets.length > 0 ?
            <View>
                <TouchableOpacity style={{ backgroundColor:Colors.brand.midnight, flexDirection: 'row', alignItems:'center'}} onPress={() => setMinimized(!minimized)}>
                    <Components.LinearDiagnal style={{ flex:1, padding:10, width: app_size.width }} label_size={16} label={'Hot Markets'} left_color={Colors.utility.warning} right_color={Colors.utility.error}/>
                    <Components.Icons.ChevronIcon direction={minimized?'down':'up'} color={Colors.shades.white} size={10} />
                </TouchableOpacity>
                {!minimized ?
                <View style={{ flexDirection:'row' }}>
                    <FlatList 
                        data={new_suggested_markets} 
                        renderItem={renderSuggestedMarkets} 
                        horizontal
                        keyExtractor={(item) => `${item.event_id}${item.event_type}${item.market_id}${item.side_id}`}
                    />
                </View>
                :<></>}
            </View>
            :<></>}
        </View>
    )
}

export default SuggestedMarkets